import { render, staticRenderFns } from "./words.vue?vue&type=template&id=7dee155b&scoped=true&"
import script from "./words.vue?vue&type=script&lang=js&"
export * from "./words.vue?vue&type=script&lang=js&"
import style0 from "./words.vue?vue&type=style&index=0&id=7dee155b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dee155b",
  null
  
)

export default component.exports